import React from 'react';
import { Text, View } from 'react-native';
import { Button, Card } from 'react-native-elements';
import AppContext from 'contexts/AppContext';
import { styles } from 'styles/components/deleteCardAlert';
import { greenColor } from 'styles/global';

interface ConfirmationModalProps {
  message: string;
  cancelButtonText: string;
  confirmButtonText: string;
  onConfirm: (...args: any[]) => any;
  onCancel: (...args: any[]) => any;
  title?: string;
}

export default ({
  title,
  message,
  cancelButtonText,
  confirmButtonText,
  onConfirm,
  onCancel,
}: ConfirmationModalProps): JSX.Element => {
  const { currentVenue } = React.useContext(AppContext);

  return (
    <>
      {title && <Card.Title style={styles.legendText}>{title}</Card.Title>}
      <Card.Divider style={[styles.titleDivider, { borderBottomColor: currentVenue?.appColor ?? greenColor }]} />
      <View>
        <Text style={styles.message}>{message}</Text>
      </View>
      <View style={styles.buttonsContainer}>
        <Button
          title={confirmButtonText}
          type="clear"
          buttonStyle={[styles.confirmDeleteCardBtn, { backgroundColor: currentVenue?.appColor ?? greenColor }]}
          titleStyle={styles.confirmDeleteCardBtnText}
          onPress={onConfirm}
        ></Button>
        <Button
          title={cancelButtonText}
          titleStyle={{ color: currentVenue?.appColor ?? greenColor }}
          containerStyle={styles.cancelBtn}
          type="clear"
          onPress={onCancel}
        ></Button>
      </View>
    </>
  );
};
